import { iconSize } from '@guardian/src-foundations/size';
import type { IconProps } from './types';

export const SvgVideo = ({ size }: IconProps) => {
	return (
		<svg
			viewBox="0 0 30 30"
			xmlns="http://www.w3.org/2000/svg"
			width={size ? iconSize[size] : undefined}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.99999 8L4 9.99999V20L5.99999 22H17.5V8H5.99999ZM24.4999 8.5L19.4999 13.5V16.5L24.4999 21.5H25.9999V8.5H24.4999Z"
			/>
		</svg>
	);
};
